import { reduxForm } from "redux-form";

import RoomForm from "./RoomForm";
import TypeForm from "./TypeForm";
import EfficiencyForm from "./EfficiencyForm";
import ModelForm from "./uPVC/ModelForm";
import upvcColourForm from "./uPVC/ColourForm";
import upvcHandleForm from "./uPVC/HandleForm";
import upvcHardwareForm from "./uPVC/HardwareForm";
import upvcSizeForm from "./uPVC/SizeForm";

import StyleForm from "./composite/StyleForm";
import compoColourForm from "./composite/ColourForm";
import FrameForm from "./composite/FrameForm";
import compoHardwareForm from "./composite/HardwareForm";
import compoHandleForm from "./composite/HandleForm";
import compoGlassForm from "./composite/GlassForm";

import validate from "./validate";

/*

    Common

*/

export const Room = {
    name: "Room",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(RoomForm)
};

export const Type = {
    name: "Type",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(TypeForm)
};

export const Efficiency = {
    name: "Efficiency",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(EfficiencyForm)
};

/*

    uPVC

*/

export const upvcModel = {
    name: "Model",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(ModelForm)
};

export const upvcColour = {
    name: "Colour",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(upvcColourForm)
};

export const upvcHandle = {
    name: "Handle",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(upvcHandleForm)
};

export const upvcHardware = {
    name: "Hardware",
    form: upvcHardwareForm
};


export const upvcSize = {
    name: "Size",
    form: upvcSizeForm
};

/*

    Composite

*/

export const compoStyle = {
    name: "Style",
    form: StyleForm
};

export const compoColour = {
    name: "Colour",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(compoColourForm)
};

export const compoFrame = {
    name: "Frame",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(FrameForm)
};

export const compoHandle = {
    name: "Handle",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(compoHandleForm)
};

export const compoHardware = {
    name: "Hardware",
    form: compoHardwareForm
};

export const compoGlass = {
    name: "Glass",
    form: reduxForm({
        form: "DoorWizard",
        destroyOnUnmount: false,
        forceUnregisterOnUnmount: true,
        validate
    })(compoGlassForm)
};



// WEBPACK FOOTER //
// ./src/containers/DoorForm/index.js